<template>
  <div class="main-doctor">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <h1 class="title-pages">FILIAL - TRANSFERÊNCIA DE USUÁRIOS</h1>

      <b-overlay :show="loading" opacity="0.99">
        <div class="v-clean p-3 mt-3">
          <!-- Descrição da funcionalidade -->
          <div class="branch-description mb-3">
            <p class="text-fourteen color-blackd mb-0">
              Selecione o usuário e a filial de destino para realizar a
              transferência.
            </p>
          </div>

          <!-- Formulário de Seleção -->
          <div class="row">
            <div class="col-md-8 mb-3">
              <label class="form-label-custom">
                <i class="fas fa-file-alt mr-2"></i>
                USUÁRIO
              </label>
              <select
                v-model="user_id"
                class="form-control form-control-enhanced"
                :disabled="loading"
              >
                <option value="">SELECIONE UM USUÁRIO...</option>
                <option v-for="user in users" :key="user.id" :value="user.id">
                  {{ user.name }} - {{ user.email }}
                  {{ user.cpf ? `(${user.cpf})` : "" }}
                </option>
              </select>
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label-custom">
                <i class="fas fa-building mr-2"></i>
                FILIAL
              </label>
              <select
                v-model="rest_home_id"
                class="form-control form-control-enhanced"
                :disabled="loading"
              >
                <option value="">SELECIONE UMA FILIAL...</option>
                <option
                  v-for="rest_home in resthomes"
                  :key="rest_home.id"
                  :value="rest_home.id"
                >
                  {{ rest_home.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- Mensagens de Erro -->
          <div v-if="errors.length > 0" class="mt-2">
            <ErrorsMessages :errors="errors" />
          </div>

          <!-- Botão de Transferência -->
          <div class="mt-3 d-flex justify-content-end">
            <confirmation-dialog
              :disabled="btnDisabled"
              header-class="modal-header"
              message-title="Deseja realmente realizar a transferência do usuário para a FILIAL selecionada?"
              message-body="Ao confirmar, não é possível reverter o processo."
              open-class="btn-save btn-transfer"
              open-left-icon="fa-exchange-alt"
              open-text="EXECUTAR TRANSFERÊNCIA"
              @yes="transfer"
            />
          </div>
        </div>

        <!-- Alerta de Aviso -->
        <div class="mt-3">
          <v-alert
            border="left"
            colored-border
            type="warning"
            elevation="2"
            class="alert-custom"
          >
            <div class="d-flex align-items-center">
              <i
                class="fas fa-exclamation-triangle mr-3 text-warning text-twenty"
              ></i>
              <div>
                <strong>Atenção:</strong> Após a transferência, não será
                possível reverter o processo. Certifique-se de que selecionou a
                filial correta antes de confirmar.
              </div>
            </div>
          </v-alert>
        </div>

        <!-- Informações Adicionais -->
        <div class="info-section mt-3 p-3">
          <h3 class="info-title">
            <i class="fas fa-info-circle mr-2"></i>
            Sobre a Transferência
          </h3>
          <ul class="info-list">
            <li>O usuário será copiado para a filial selecionada</li>
            <li>Todas as informações cadastrais serão mantidas</li>
            <li>A transferência é permanente e não pode ser desfeita</li>
            <li>Certifique-se de ter permissão para realizar esta operação</li>
          </ul>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar.vue";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired.vue";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog.vue";
import api from "../services/api";
import toast from "../lib/ToastNotification";
import { getRestHomeSelectedFinancialAccount } from "../lib/functions";

export default {
  name: "BranchUser",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    ConfirmationDialog,
  },

  data() {
    return {
      users: [],
      user_id: "",
      resthomes: [],
      rest_home_id: "",
      errors: [],
      loading: false,
    };
  },

  computed: {
    btnDisabled() {
      let { loading, user_id, rest_home_id } = this;

      if (loading) return true;
      if (!user_id) return true;
      if (!rest_home_id) return true;

      return false;
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    getRestHomeSelectedFinancialAccount,

    retrieve() {
      this.errors = [];
      this.getForms();
      this.getRestHomes();
    },

    async getForms() {
      try {
        this.loading = true;

        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = users;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async getRestHomes() {
      try {
        this.loading = true;
        const response = await api.get("/resthomes");
        const { error, errors, resthomes } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.resthomes = resthomes;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async transfer() {
      try {
        this.loading = true;
        let { user_id, rest_home_id } = this;
        let data = { user_id, rest_home_id };
        let response = await api.post("/branch-user/transfer", data);
        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          toast(message, "success");
          this.user_id = "";
          this.rest_home_id = "";
          this.retrieve();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* Container Principal */
.v-clean {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Descrição da Funcionalidade */
.branch-description {
  background-color: #f8f8f7;
  padding: 12px 16px;
  border-left: 4px solid #33495e;
  border-radius: 4px;
}

/* Labels dos Formulários */
.form-label-custom {
  font-size: 13px;
  color: #33495e;
  text-transform: uppercase;
  margin-bottom: 8px;
  display: block;
  letter-spacing: 0.5px;
}

/* Select Inputs Melhorados */
.form-control-enhanced {
  font-size: 15px;
  color: #444;
  border: 2px solid #ddd;
  border-radius: 4px;
  padding: 10px 12px;
  transition: all 0.3s ease;
  background-color: #fff;
  height: auto;
}

.form-control-enhanced:focus {
  border-color: #33495e;
  box-shadow: 0 0 0 0.2rem rgba(51, 73, 94, 0.15);
  outline: none;
}

.form-control-enhanced:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.form-control-enhanced option {
  padding: 10px;
  font-size: 15px;
}

/* Botão de Transferência */
.btn-transfer {
  min-width: 240px;
  padding: 12px 24px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

.btn-transfer:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.btn-transfer:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Alerta Customizado */
.alert-custom {
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.6;
}

/* Seção de Informações */
.info-section {
  background-color: #f8f8f7;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.info-title {
  font-size: 16px;
  color: #33495e;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #33495e;
}

.info-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.info-list li {
  font-size: 14px;
  color: #444;
  padding: 6px 0;
  padding-left: 24px;
  position: relative;
}

.info-list li:before {
  content: "•";
  color: #33495e;
  font-weight: bold;
  font-size: 18px;
  position: absolute;
  left: 8px;
}

/* Ícones */
.fas {
  color: #33495e;
}

/* Responsividade */
@media (max-width: 768px) {
  .title-pages {
    font-size: 20px;
  }

  .form-label-custom {
    font-size: 12px;
  }

  .form-control-enhanced {
    font-size: 14px;
  }

  .btn-transfer {
    min-width: 100%;
    margin-top: 10px;
  }

  .branch-description p {
    font-size: 13px;
  }

  .info-list li {
    font-size: 13px;
  }
}

@media (max-width: 576px) {
  .v-clean {
    padding: 16px !important;
  }

  .info-section {
    padding: 16px !important;
  }
}

/* Acessibilidade - Foco Visível */
.form-control-enhanced:focus,
button:focus {
  outline: 3px solid rgba(51, 73, 94, 0.3);
  outline-offset: 2px;
}

/* Melhor contraste para leitura */
.color-blackd {
  color: #333 !important;
}

/* Loading State */
.b-overlay {
  min-height: 200px;
}
</style>